<template>
  <el-container>
    <!-- <el-header style="width: 1350px; padding: 0"> -->
    <el-header style="width: 1330px; padding: 0">
      <el-container style="height: 720px">
        <el-aside width="57.2rem" style="background-color: #EEE; font-size: 1.4rem">
          <el-row style="padding: 0.5rem; line-height: 3rem">
            <el-col :span="8">姓名：{{ orderInfo.realName }}</el-col>
            <el-col :span="8">账户可用额：{{ orderInfo.userAccountBalance }}</el-col>
            <el-col :span="8">读取时间：{{ orderInfo.readTime }}</el-col>
          </el-row>
          <el-row style="padding: 0.5rem; line-height: 3rem">
            <el-col :span="8">时段：{{ orderInfo.partOfDay }}</el-col>
            <el-col :span="8">合计：{{ orderInfo.orderAmount }}</el-col>
            <el-col :span="8">取餐状态：{{ orderInfo.orderStatus }}</el-col>
          </el-row>
          <el-row style="height: 465px">
            <el-table :data="orderInfo.orderDetailList" border stripe style="font-size: 1.4rem; line-height:3rem">
              <el-table-column prop="goodsName" label="菜品" width="632"></el-table-column>
              <el-table-column prop="qty" label="份数" width="80"></el-table-column>
              <el-table-column prop="goodsPrice" label="单价" width="100" :formatter="yuanOfGoodsPriceFormatter"></el-table-column>
              <el-table-column prop="detailAmount" label="总额" width="100" :formatter="yuanOfDetailAmountFormatter"></el-table-column>
            </el-table>
          </el-row>
          <el-row style="height: 6rem; font-size: 1.3rem">
            <el-tag v-for="(value, key) in remainOrder.leftCuisine" :key="key" effect="plain" style="font-size: 1.2rem">{{key}}：{{value}}</el-tag>
          </el-row>
          <el-row style="height: 2rem; font-size: 1.2rem; color: #666">
              <el-col :span="2" style="color: #666" >未取餐</el-col>
              <el-col :span="22">{{ remainOrder.leftStaffRealName }}</el-col>
            </el-row>
        </el-aside>
        <el-main style="height: 720px; padding: 0; text-align: center; font-size: 1.4rem">
          <el-row style="height: 28rem; padding: 0.5rem 0.5rem; background-color: #EEE">
            <el-col :span="17">
              <el-row style="height: 3rem; line-height: 3rem">
                <el-input :class="focusAt=='userNo'?'is_focus':''" v-model="userNo" :maxlength="10" placeholder="请输入工号" @focus="focusAt='userNo'"></el-input>
              </el-row>
              <el-row style="height: 18rem; margin: 1.5rem 0; padding: 0 0;">
                <el-button class="number-button" style="margin-top:0.25rem" @click="typeNum('1')">
                  <font style="font-size: 3rem">1</font>
                </el-button>
                <el-button class="number-button" style="margin-top:0.25rem" @click="typeNum('2')">
                  <font style="font-size: 3rem">2</font>
                </el-button>
                <el-button class="number-button" style="margin-top:0.25rem" @click="typeNum('3')">
                  <font style="font-size: 3rem">3</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('4')">
                  <font style="font-size: 3rem">4</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('5')">
                  <font style="font-size: 3rem">5</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('6')">
                  <font style="font-size: 3rem">6</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('7')">
                  <font style="font-size: 3rem">7</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('8')">
                  <font style="font-size: 3rem">8</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('9')">
                  <font style="font-size: 3rem">9</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('0')">
                  <font style="font-size: 3rem">0</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('.')">
                  <font style="font-size: 3rem">.</font>
                </el-button>
                <el-button class="number-button" @click="typeNum('')">
                  <font style="font-size: 3rem">空</font>
                </el-button>
              </el-row>
              <el-row style="height: 3rem; line-height: 3rem">
                <el-input-number :class="focusAt=='tempAmount'?'is_focus':''" :min="0" :max="999.99" :precision="2" v-model="tempAmount" placeholder="金额" @focus="focusAt='tempAmount'"></el-input-number>
              </el-row>
            </el-col>
            <el-col :span="7" style="padding-left: 1rem;">
              <el-button type="primary" style="width: 100%" @click="swipeByUserNo">取<br>餐</el-button>
              <el-row style="height: 2.5rem; line-height: 2.5rem">
                {{ dateStr }}
              </el-row>
              <el-row style="height: 2.5rem; line-height: 2.5rem">
                {{ weekDayStr }}
              </el-row>
              <el-row style="height: 2.5rem; line-height: 2.5rem">
                {{ partOfDay }}
              </el-row>
              <el-row style="height: 2.5rem; line-height: 2.5rem">
                {{ timeStr }}
              </el-row>
              <el-button type="primary" style="width: 100%; margin: 0 0 0 0" @click="handleUnplannedOrder">加<br>餐</el-button>
            </el-col>
          </el-row>
          <el-row style="height: 17rem; padding: 0.5rem 0.5rem; background-color: #EEE">
            <el-col :span="9" >
              <el-row style="height: 8.7rem">
              </el-row>
              <el-row style="height: 3rem; padding: 0; font-size: 1.1rem; line-height: 1.2rem">
                设备ID: <br>{{ deviceNo }}<br>{{ connectStatus }}
              </el-row>
            </el-col>
            <el-col :span="15" style="height: 16rem; padding: 0;">
              <img style="width: 16rem; margin: 0; padding: 0" :src="canteenQrCode" />
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-header>
  </el-container>
</template>

<script>
export default ({
  data () {
    return {
      loginForm: {
        userName: '',
        password: '',
        userType: '2'
      },
      websock: null,
      dateStr: '',
      weekDayStr: '',
      timeStr: '',
      partOfDay: '',
      connectStatus: '',
      deviceNo: '',
      orderInfo: {},
      userNo: '',
      tempAmount: 0,
      focusAt: 'userNo',
      typeDotFlag: null,
      canteenQrCode: '',
      getCanteenQrCodeInterval: null,
      getHeartBeatInterval: null,
      remainOrder: {
        leftCuisine: {},
        leftStaffRealName: ''
      }
    }
  },
  computed: {
    userTypeDisable () {
      return !/^\d{11}$/.test(this.loginForm.userName)
    }
  },
  mounted () {
    this.getDeviceNo()
    this.getTime()
  },
  created () {
    this.initWebSocket()
  },
  destroyed () {
    this.websock.close()
  },
  methods: {
    getDeviceNo () {
      let deviceNoArr = /no=([^#]+)/.exec(window.location.href)
      if (deviceNoArr !== null && deviceNoArr[1] != null) {
        this.deviceNo = '202101' + ('0000' + deviceNoArr[1]).slice(-4)
      }
    },
    getTime () {
      let _this = this
      this.$axios.get(this.GLOBAL.host + '/time').then(res => {
        if (res.data && res.data.status === 200 && res.data.data) {
          let timestamp = res.data.data
          setInterval(function () {
            timestamp += 1
            let time = new Date(timestamp * 1000)
            let month = time.getMonth() + 1
            let date = time.getDate()
            let weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
            let weekDay = weekDays[time.getDay()]
            let hours = '0' + time.getHours()
            let minutes = '0' + time.getMinutes()
            let seconds = '0' + time.getSeconds()
            _this.dateStr = month + '月' + date + '日'
            _this.weekDayStr = weekDay
            _this.timeStr = hours.substr(-2) + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)
            if (_this.timeStr < '10:00:00') {
              _this.partOfDay = '早餐时间'
            } else if (_this.timeStr < '15:00:00') {
              _this.partOfDay = '午餐时间'
            } else {
              _this.partOfDay = '晚餐时间'
            }
          }, 1000)
        }
      })
    },
    swipeByUserNo () {
      let _this = this
      if (this.deviceNo === '') {
        this.$message.warning('设备异常')
        return
      }
      if (this.userNo === '') {
        this.$message.warning('请输入工号')
        return
      }
      this.$axios.get(this.GLOBAL.host + '/canteenOrder/swipeCard', {
        params: {
          deviceNo: _this.deviceNo,
          userNo: _this.userNo
        }
      }).then(res => {
        if (res.data) {
          if (res.data.status === 200) {
            this.$message.success(res.data.message)
            _this.userNo = ''
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    handleUnplannedOrder () {
      if (this.orderInfo === undefined || this.orderInfo.userId === undefined) {
        this.$message.warning('请先刷卡获取用户信息')
        return
      }
      let _this = this
      this.$confirm('', '请确认加餐' + _this.tempAmount + '元？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.get(this.GLOBAL.host + '/canteenOrder/handleUnplannedOrder', {
          params: {
            deviceNo: _this.deviceNo,
            userId: _this.orderInfo.userId,
            amount: (_this.tempAmount * 100).toFixed(0)
          }
        }).then(res => {
          if (res.data) {
            if (res.data.status === 200) {
              _this.tempAmount = 0
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    yuanOfGoodsPriceFormatter (row) {
      return this.fenToyuanFormat(row.goodsPrice)
    },
    yuanOfDetailAmountFormatter (row) {
      return this.fenToyuanFormat(row.detailAmount)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    },
    typeNum (num) {
      console.log('++++++++++++++++++++')
      console.log('this.focusAt: ' + this.focusAt)
      console.log('this.tempAmount: ' + this.tempAmount)
      console.log('typeof this.tempAmount: ' + typeof this.tempAmount)
      console.log('typeof num: ' + typeof num)
      console.log('--------------------')
      if (this.focusAt === 'userNo') {
        if (num === '') {
          this.userNo = ''
        } else if (this.userNo.length >= 10) {
        } else {
          this.userNo += num
        }
      } else if (this.focusAt === 'tempAmount') {
        if (num === '') {
          this.tempAmount = 0
          this.typeDotFlag = null
        } else if (num === '.') {
          this.typeDotFlag = 0
        } else {
          if (this.typeDotFlag === 0) {
            this.tempAmount = Math.trunc(this.tempAmount) + num / 10
            this.typeDotFlag = 1
          } else if (this.typeDotFlag === 1) {
            let digitalAfterDot = this.tempAmount.toFixed(1) * 10 % 10
            this.tempAmount = Math.trunc(this.tempAmount) + digitalAfterDot / 10 + num / 100
            this.typeDotFlag = 2
          } else if (this.typeDotFlag >= 2) {
          } else {
            this.tempAmount += num
          }
        }
      }
    },
    getCanteenQrCode () {
      let _this = this
      clearInterval(this.getCanteenQrCodeInterval)
      this.websocketsend('getCanteenQrCode_' + this.deviceNo)
      this.getCanteenQrCodeInterval = setInterval(function () {
        _this.websocketsend('getCanteenQrCode_' + _this.deviceNo)
      }, 600 * 1000)
    },
    getHeartBeat () {
      let _this = this
      clearInterval(this.getHeartBeatInterval)
      this.websocketsend('getHeartBeat_' + this.deviceNo)
      this.getHeartBeatInterval = setInterval(function () {
        _this.websocketsend('getHeartBeat_' + _this.deviceNo)
      }, 20 * 1000)
    },
    initWebSocket () {
      // 初始化weosocket
      this.connectStatus = '正在连接'
      this.websock = new WebSocket(this.GLOBAL.wsHost)
      this.websock.onopen = this.websocketonopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen () {
      this.connectStatus = '已连接'
      // 连接建立之后执行send方法发送数据
      this.websocketsend('bindCanteenDevice_' + this.deviceNo)
      if (this.dateStr === '' || this.timeStr === '' || this.partOfDay === '') {
        this.getTime()
      }
      this.getCanteenQrCode()
      this.getHeartBeat()
    },
    websocketonerror () {
      // 连接建立失败
      // console.log('连接失败')
    },
    websocketonmessage (e) {
      // 数据接收
      // console.log('receive message: ' + e.data)
      let _this = this
      if (e.data != null) {
        console.log(e.data)
        if (e.data.substring(0, 17) === 'sendCanteenOrder_') {
          _this.orderInfo = JSON.parse(e.data.substring(17))
          this.getCanteenQrCode()
        } else if (e.data.substring(0, 18) === 'sendCanteenQrCode_') {
          let message = JSON.parse(e.data.substring(18))
          if (message != null && message.canteenQrCode != null) {
            this.canteenQrCode = message.canteenQrCode
          }
        } else if (e.data.substring(0, 23) === 'sendCanteenRemainOrder_') {
          let message = JSON.parse(e.data.substring(23))
          if (message != null && message.leftCuisine != null && message.leftStaffRealName != null) {
            this.remainOrder.leftCuisine = message.leftCuisine
            this.remainOrder.leftStaffRealName = message.leftStaffRealName
          }
        }
      }
    },
    websocketsend (Data) {
      // 数据发送
      this.websock.send(Data)
    },
    websocketclose (e) {
      // 断开连接
      this.connectStatus = '连接失败，尝试重新连接'
      let _this = this
      setTimeout(function () {
        _this.initWebSocket()
      }, 5000)
    }
  }
})
</script>
<style>
.el-input__inner {
  width: 16.5rem !important;
  height: 3rem !important;
  line-height: 3rem !important;
  font-size: 2.8rem !important;
}
.el-button {
  height: 8.5rem;
  line-height: 3.6rem !important;
  font-size: 3.6rem !important;
  padding: 0 !important;
}
.el-input-number {
  width: 16.5rem !important;
  font-size: 2.8rem !important;
}
.el-input-number__decrease, .el-input-number__increase {
  height: 2.8rem;
  width: 2.8rem;
  font-size: 2.8rem;
  line-height: 2.8rem;
  padding-top: 0.1rem;
}
.number-button {
  width: 4.25rem;
  height: 3.6rem;
  line-height: 3.6rem !important;
  padding: 0 !important;
  margin: 0.45rem 0.5rem !important;
}
.is_focus input {
  background-color: yellow;
}
</style>



// WEBPACK FOOTER //
// src/components/CanteenStaffSide.vue